<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vi"></a><a id="page_vii"></a><a id="contents"></a><strong>Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/preface"><em>Preface</em></a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/acknowledgments"><em>Acknowledgments</em></a></p>
<p class="tocfront1"><a class="nounder" href="#/xhtml/introduction">Introduction: What Is an Idea?</a></p>
<p class="tocpart"><a class="nounder" href="#/xhtml/part001#part001">Part I: Ten Ways to idea-Condition Your Mind</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">1 Have Fun</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 Be More Like a Child</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 Become Idea-Prone</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Visualize Success</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Rejoice in Failure</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Get More Inputs</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 Screw Up Your Courage</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 Team Up with Energy</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 Rethink Your Thinking</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 Learn How to Combine</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part002#part002" title="Link target outside of Sample">Part II: A Five Step Method for Producing ideas</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 Define the Problem</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12 Gather the Information</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">13 Search for the Idea</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">14 Forget about It</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">15 Put the Idea into Action</span></p>
<p class="tocback1"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/illustrator" title="Link target outside of Sample">About the Illustrator</span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1b644151